import React from 'react';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import { paths } from '@/app/paths';
import { FolioDrawer } from '@/components/Drawers/FolioDrawer';
import { UserForm } from './UserForm';
import { NewUserForm } from './NewUserForm';

const LIST_PATH = `${paths.admin}/users`;

/**
 * The user drawer: editing one user while the URL is /admin/users/:userId (a row click), or
 * creating one at /admin/users/new (the New user button). Always rendered by the list page,
 * not by the route, so FolioDrawer can animate opening and closing. Closing goes back to
 * the list, keeping its search. A click outside or Escape asks before closing with unsaved
 * changes (FolioDrawerFormGuard in the form).
 */
export const UserDrawer = () => {
	const userId = useMatch(`${LIST_PATH}/:userId`)?.params.userId;
	const navigate = useNavigate();
	const { search } = useLocation();

	const handleClose = () => navigate({ pathname: LIST_PATH, search });

	return (
		<FolioDrawer open={Boolean(userId)} onClose={handleClose}>
			{userId === 'new' && (
				<NewUserForm
					onClose={handleClose}
					onCreated={(id) => navigate({ pathname: `${LIST_PATH}/${id}`, search })}
				/>
			)}
			{userId && userId !== 'new' && (
				<UserForm key={userId} userId={userId} onClose={handleClose} />
			)}
		</FolioDrawer>
	);
};
